import ReportCategoryModel from "@/models/ReportCategoryModel";

export default class ReportCategoriesState {
  categories?: ReportCategoryModel[];
  loaded = false;
}
